import convert from 'heic-convert/browser'

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    contentTypes: { type: Array, default: [] }
  }

  connect() {
    this.element.addEventListener('trix-file-accept', this.screenFile.bind(this))

    if (this.contentTypesValue.length === 0) {
      this.element.addEventListener('trix-attachment-add', event => event.attachment.remove())
    } else {
      this.element.addEventListener('trix-attachment-add', this.uploadInlineImage.bind(this))
    }
  }

  // Trix turns an <img> in pasted HTML into an attachment with no file, so a data:
  // image would never upload and its bytes would be posted inline with the form.
  async uploadInlineImage({ attachment }) {
    const url = attachment.getURL()
    if (!url?.startsWith('data:')) return

    const blob = await fetch(url).then(response => response.blob())
    const file = new File([blob], 'pasted-image', { type: blob.type })
    const editor = this.element.editor
    const selectedRange = editor.getSelectedRange()

    editor.setSelectedRange(editor.getDocument().getRangeOfAttachment(attachment.attachment))
    editor.insertFile(file)
    attachment.remove() // Still there if screenFile rejected the file
    editor.setSelectedRange(selectedRange)
  }

  screenFile(event) {
    if (!this.contentTypesValue.includes(event.file.type)) {
      event.preventDefault()
      alert(`${event.file.type} is not a supported file type.`)
    } else if (event.file.type === 'image/heic') {
      event.preventDefault()

      this.convert(event.file).then((file) => {
        event.target.editor.insertFile(file)
      })
    }
  }

  async convert(file) {
    const buffer = await file.arrayBuffer()
    const uint8 = new Uint8Array(buffer)

    const outputBuffer = await convert({
      buffer: uint8, format: 'JPEG', quality: 0.8
    })

    const blob = new Blob([outputBuffer], { type: 'image/jpeg' })
    const name = `${file.name.replace(/\.heic$/i, '')}.jpeg`
    return new File([blob], name, { type: 'image/jpeg' })
  }

  process() {
    const attachments = this.element.editor.getDocument().getAttachments()
    this.dispatch('uploading', { detail: attachments.some(attachment => attachment.isPending()) })
  }
}
